import { InjectionToken } from '@angular/core';

export const WCL_PARENT_MODULE = new InjectionToken<WclParentModule>('WCL_PARENT_MODULE');

export enum WclParentModule {
    BUSINESS_USER = 'business-user',
    OUTLET_MANAGER = 'outlet-manager',
}
